import React from "react";

export default function BookApplicationSubmitted(props) {
    return (
        <>
            <div className="application-submitted">
                <h1 className="header">Your Application Has Been Recieved!</h1>
                <h2 className="header">Thanks for your application {props.name}!</h2>
                <h2 className="header">Your Application Token is: {props.token}</h2>
                <p>We've sent you a confirmation email to your address {props.email}.</p>
                <p>Our staff has recieved the application and will review it as soon as possible.</p>
            </div>
        </>
    )
}